import React, { memo } from 'react';
import { css } from 'linaria';
import { DesignRegistrationPanel, PanelActionBlock } from 'common/components';
import { KITCHEN_ELEMENT_BLOCK } from '../../../kitchen-constants';
import {
  KITCHEN_DESIGNER_HREF,
  KITCHEN_PANEL_STRUCTURE,
  KITCHEN_PANEL_TEXT,
  KITCHEN_PANEL_TEXT_KZ,
} from './kitchen-design-panel-constants';

const kitchenDesignPanelSection = css`
  @media (--from-desktop) {
    min-height: 114px;
  }
`;

type KitchenDesignPanelProps = {
  isConsultationFormVisible?: boolean;
  isRuRegion: boolean;
  signUpHref: string;
  withWhiteBackground?: boolean;
};

export const KitchenDesignPanel: React.FC<KitchenDesignPanelProps> = memo(
  ({ signUpHref, isConsultationFormVisible = false, isRuRegion, withWhiteBackground = false }) => {
    const text = isRuRegion ? KITCHEN_PANEL_TEXT : KITCHEN_PANEL_TEXT_KZ;

    return (
      <DesignRegistrationPanel
        isConsultationFormVisible={isConsultationFormVisible}
        withWhiteBackground={withWhiteBackground}
        className={kitchenDesignPanelSection}
        newVersion
        structure={{
          panel: {
            ...KITCHEN_PANEL_STRUCTURE.panel,
            content: {
              ...KITCHEN_PANEL_STRUCTURE.panel.content,
              text,
            },
            actionBlock: [
              ...(
                isRuRegion
                  ? [{
                    elementBlock: KITCHEN_ELEMENT_BLOCK,
                    invert: true,
                    label: 'Спроектировать самому',
                    variant: 'pseudo',
                    href: KITCHEN_DESIGNER_HREF,
                    target: '_blank',
                  }] : []
              ) as PanelActionBlock[],
              {
                elementBlock: KITCHEN_ELEMENT_BLOCK,
                href: signUpHref,
                label: 'Записаться на проектирование',
                target: '_blank',
                variant: 'accent',
              },
            ],
          },
          mobilePanel: {
            ...KITCHEN_PANEL_STRUCTURE.mobilePanel,
            content: {
              ...KITCHEN_PANEL_STRUCTURE.mobilePanel.content,
              text,
            },
            actionBlock: [
              {
                elementBlock: KITCHEN_ELEMENT_BLOCK,
                href: signUpHref,
                label: 'Записаться на проектирование',
                target: '_blank',
                variant: 'accent',
              },
              ...(
                isRuRegion
                  ? [{
                    elementBlock: KITCHEN_ELEMENT_BLOCK,
                    invert: true,
                    label: 'Спроектировать самому',
                    variant: 'pseudo',
                    href: KITCHEN_DESIGNER_HREF,
                    target: '_blank',
                  }] : []
              ) as PanelActionBlock[],
            ],
          },
        }}
      />
    )
  }
);
